<div class="d-flex jc-center mb-medium" *ngIf="clientType === '3'">
    <mat-button-toggle-group name="planes" aria-label="seleccion de planes" class="mat-button-toggle-group--green">
        <mat-button-toggle (click)="selectType(1, 'Planes mensuales')" value="Planes mensuales" checked>Planes mensuales</mat-button-toggle>
        <mat-button-toggle (click)="selectType(2, 'Planes trimestrales')" value="Planes trimestrales">Planes trimestrales</mat-button-toggle>
    </mat-button-toggle-group>
</div>
<owl-carousel-o [options]="OwlOptions" *ngIf="clientType !== '3' && clientType !== '2' ">
    <ng-template carouselSlide *ngFor="let item of dataPlan; index as i">
        <div class="ideal-card inmobiliarias">
            <div class="ideal-card__image {{dataPlan[i].colorCard}}">
                <div class="grid-2-col">
                    <div class="grid-row-1">
                        <picture>
                            <source media="(min-width: 990px)" srcset="{{image_url + dataPlan[i].image_url}}.png">
                            <source media="(max-width: 989px)" srcset="{{image_url + dataPlan[i].image_url}}-mobile.png">
                            <img class="img-responsive" lazyLoad="{{image_url + dataPlan[i].image_url}}-mobile.png" [alt]="item.name ? 'Publicación de inmuebles ' + item.name + ' Ciencuadras' :'happy people image'">
                        </picture>
                    </div>
                    <div class="grid-row-1">
                        <div class="grid-row-3">
                            <span class="type text-title">{{dataPlan[i].name}}</span>
                            <small class="price__validity">{{dataPlan[i].descriptionValuePlan}}</small>
                            <span class="price text-price" *ngIf="dataPlan[i].discount > 0 && dataPlan[i].discount !== null">
                                $ {{dataPlan[i].price.toLocaleString()}}
                            </span>
                            <span *ngIf="dataPlan[i].discount === null" class="price text-price">$ {{dataPlan[i].priceDiscount.toLocaleString()}}</span>
                            <small *ngIf="dataPlan[i].iva != 0" class="price__validity">Iva incluido</small>
                        </div>
                    </div>
                </div>
                <span *ngIf="dataPlan[i].discount > 0  && dataPlan[i].discount !== null" class="discount-rate bg-tertiary-base text-grayscale-white text-xsmall">-{{dataPlan[i].discount}}%</span>
            </div>
            <div class="ideal-card__description">
                <div class="center-div">
                    <span class="txt-select">Selecciona la cantidad de meses</span>
                </div>
                <div class="center-div">
                    <select class="select-desing txt-select" #selectList (change)="changePlans(selectList.value, dataPlan[i])">
                        <option value="{{dataPlan[i].id}}">{{dataPlan[i].validity}} {{dataPlan[i].unit_validity}}</option>
                        <option *ngFor="let mes of dataPlan[i].meses" value="{{mes.id}}">
                            {{mes.validity}} {{mes.unit_validity}}
                        </option>
                    </select>
                </div>
                <div class="center-div">
                    <button class="button tertiary rounded text-xsmall py-tiny mt-xsmall mb-thumb btn-txt" type="button" [attr.data-qa-id]="'cc_pr_btn_plan_id_'+dataPlan[i].id" (click)="onClickSelectPlan(dataPlan[i])">Seleccionar</button>
                </div>                
                <hr class="hr-desing">
            </div>
            <div class="ideal-card__properties">
                <ul class="list">
                    <li class="item" *ngFor="let item of dataPlan[i].summary; index as j">
                        <span class="icon icon-check_circle_outline icon-color"></span>
                        <span> {{dataPlan[i].summary[j]}}</span>
                    </li>
                </ul>
            </div>
            <div *ngIf="dataPlan[i].termsDescription !== null" class="ideal-card__warning">
                <hr class="hr-desing">
                <small>{{dataPlan[i].termsDescription}}</small>
                <hr class="hr-desing">
            </div>
            <button class="btn-ideal" type="button" (click)="openDetailDialog(dataPlan[i].name)">Ver más detalles<span class="icon icon-arrow-right"></span></button>
        </div>
    </ng-template>

</owl-carousel-o>

<owl-carousel-o class="carouselAgente" [options]="OwlOptionsSecondary" *ngIf="clientType === '2' ">
    <ng-template carouselSlide *ngFor="let item of dataPlan; index as i">
        <div class="ideal-card inmobiliarias agentes">
            <div class="ideal-card__image {{dataPlan[i].colorCard}}">
                <div class="grid-2-col">
                    <div class="grid-row-1">
                        <picture>
                            <source media="(min-width: 990px)" srcset="{{image_url + dataPlan[i].image_url}}.png">
                            <source media="(max-width: 989px)" srcset="{{image_url + dataPlan[i].image_url}}-mobile.png">
                            <img class="img-responsive" lazyLoad="{{image_url + dataPlan[i].image_url}}-mobile.png" [alt]="item.name ? 'Publicación de inmuebles ' + item.name + ' Ciencuadras' :'happy people image'">
                        </picture>
                    </div>
                    <div class="grid-row-1">
                        <div class="grid-row-3">
                            <span class="type text-title">{{dataPlan[i].name}}</span>
                            <small class="price__validity">{{dataPlan[i].descriptionValuePlan}}</small>
                            <span class="price text-price" *ngIf="dataPlan[i].discount > 0 && dataPlan[i].discount !== null">
                                $ {{dataPlan[i].price.toLocaleString()}}
                            </span>
                            <span *ngIf="dataPlan[i].discount === null" class="price text-price">$ {{dataPlan[i].priceDiscount.toLocaleString()}}</span>
                            <small *ngIf="dataPlan[i].iva != 0" class="price__validity">Iva incluido</small>
                        </div>
                    </div>
                </div>
                <span *ngIf="dataPlan[i].discount > 0  && dataPlan[i].discount !== null" class="discount-rate bg-tertiary-base text-grayscale-white text-xsmall">-{{dataPlan[i].discount}}%</span>
            </div>
            <div class="ideal-card__description">
                <div class="center-div">
                    <span class="txt-select">Selecciona la cantidad de meses</span>
                </div>
                <div class="center-div">
                    <select class="select-desing txt-select" #selectList (change)="changePlans(selectList.value, dataPlan[i])">
                        <option value="{{dataPlan[i].id}}">{{dataPlan[i].validity}} {{dataPlan[i].unit_validity}}</option>
                        <option *ngFor="let mes of dataPlan[i].meses" value="{{mes.id}}">
                            {{mes.validity}} {{mes.unit_validity}}
                        </option>
                    </select>
                </div>
                <div class="center-div">
                    <button class="button tertiary rounded text-xsmall py-tiny mt-xsmall mb-thumb btn-txt" type="button" [attr.data-qa-id]="'cc_pr_btn_plan_id_'+dataPlan[i].id" (click)="onClickSelectPlan(dataPlan[i])">Seleccionar</button>
                </div>
                <hr class="hr-desing">
            </div>
            <div class="ideal-card__properties">
                <ul class="list">
                    <li class="item" *ngFor="let item of dataPlan[i].summary; index as j">
                        <span class="icon icon-check_circle_outline icon-color"></span>
                        <span> {{dataPlan[i].summary[j]}}</span>
                    </li>
                </ul>
            </div>
            <div *ngIf="dataPlan[i].termsDescription !== null" class="ideal-card__warning">
                <hr class="hr-desing">
                <small>{{dataPlan[i].termsDescription}}</small>
                <hr class="hr-desing">
            </div>
            <button class="btn-ideal" type="button" (click)="openDetailDialog(dataPlan[i].name)">Ver más detalles<span class="icon icon-arrow-right"></span></button>
        </div>
    </ng-template>

</owl-carousel-o>

<owl-carousel-o [options]="OwlOptions" class="" *ngIf="clientType === '3'" style="width: 360px;">
    <ng-template carouselSlide *ngFor="let item of dataPlanConstructionCompany; index as i">
        <div class="ideal-card constructoras {{dataPlanConstructionCompany[i].colorCard}}">
            <div class="ideal-card__image">
                <div class="grid-2-col">
                    <div class="grid-row-1">
                        <picture>
                            <source media="(max-width: 989px)" srcset="{{image_url + dataPlanConstructionCompany[i].image_url}}-mobile.png">
                            <source media="(min-width: 990px)" srcset="{{image_url + dataPlanConstructionCompany[i].image_url}}.png">
                            <img class="img-responsive" lazyLoad="{{image_url + dataPlanConstructionCompany[i].image_url}}-mobile.png" [alt]="item.name ? 'Publicación de inmuebles ' + item.name + ' Ciencuadras' :'happy people image'">
                        </picture>
                        <span *ngIf="dataPlanConstructionCompany[i].discount > 0  && dataPlan[i].discount !== null" class="discount-rate bg-tertiary-base text-grayscale-white text-xsmall">-{{dataPlanConstructionCompany[i].discount}}%</span>
                    </div>
                    <div class="grid-row-1">
                        <span class="type text-title">{{dataPlanConstructionCompany[i].name}}</span>
                        <span class="discount" *ngIf="dataPlanConstructionCompany[i].discount > 0  && dataPlan[i].discount !== null">
                            ${{dataPlanConstructionCompany[i].price.toLocaleString()}}
                        </span>
                        <span class="price text-price">${{dataPlanConstructionCompany[i].priceDiscount.toLocaleString()}}
                            
                        </span>
                        <small class="price__validity">{{dataPlanConstructionCompany[i].descriptionValuePlan}}</small>
                    </div>
                </div>
            </div>
            <div class="ideal-card__description">
                
                <div class="center-div">
                    <button class="button tertiary rounded text-xsmall py-tiny mt-xsmall mb-thumb" type="button" [attr.data-qa-id]="'cc_pr_btn_plan_id_'+dataPlan[i].id" (click)="onClickSelectPlan(dataPlanConstructionCompany[i])">Seleccionar</button>
                </div>

            </div>
            <div class="ideal-card__properties">
                <ul class="list">
                    <li class="item" style="color: #FFFF;" *ngFor="let item of dataPlanConstructionCompany[i].summary; index as j">{{dataPlanConstructionCompany[i].summary[j]}}</li>
                </ul>
            </div>
            <div class="ideal-card__warning">
                <small style="color: #FFFF;">{{dataPlanConstructionCompany[i].termsDescription}}</small>
            </div>
        </div>
    </ng-template>

</owl-carousel-o>